import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

export type StoreWorkflow = "app_store_connect" | "google_play";

type StoreWorkflowSelectorProps = {
  value: StoreWorkflow;
  onChange: (value: StoreWorkflow) => void;
};

const StoreWorkflowSelector: React.FC<StoreWorkflowSelectorProps> = ({
  value,
  onChange,
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
        Select your workflow
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Choose the store you want to configure subscriptions for.
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_event, nextValue) => {
          if (nextValue) {
            onChange(nextValue as StoreWorkflow);
          }
        }}
        size="small"
      >
        <ToggleButton value="app_store_connect">App Store Connect</ToggleButton>
        <ToggleButton value="google_play">Google Play</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default StoreWorkflowSelector;
